import React from "react";
import { NO_ALLOCATION_LABEL } from "@features/admin/finance/financeCalcTypes";
import { summarizeDeductibles } from "@features/admin/finance/deductibleConfigUtils";
import { DeductibleConfig } from "@features/admin/finance/types/deductibleConfig";

interface DeductibleSummaryProps {
    deductibles: DeductibleConfig[] | null | undefined;
    max?: number;
    testId?: string;
}

/** First few configured deductibles (list order) with a "+n more" line; inactive ones are muted. */
const DeductibleSummary: React.FC<DeductibleSummaryProps> = ({ deductibles, max = 3, testId }) => {
    const { items, moreCount } = summarizeDeductibles(deductibles, max);
    if (items.length === 0) return <span className="text-muted" data-testid={testId}>{NO_ALLOCATION_LABEL}</span>;

    return (
        <div className="d-flex flex-column lh-sm" data-testid={testId}>
            {items.map((item) => (
                <span key={item.deductible_id} className={item.is_active ? undefined : "text-muted fst-italic"}>
                    {item.label}{item.is_active ? "" : " (inactive)"}
                </span>
            ))}
            {moreCount > 0 && <span className="text-muted">+{moreCount} more</span>}
        </div>
    );
};

/** Plain-text summary for compact layouts such as mobile cards. */
export const deductibleSummaryText = (deductibles: DeductibleConfig[] | null | undefined, max: number = 3): string => {
    const { items, moreCount } = summarizeDeductibles(deductibles, max);
    if (items.length === 0) return NO_ALLOCATION_LABEL;
    const text = items.map((i) => i.label).join(" · ");
    return moreCount > 0 ? `${text} · +${moreCount} more` : text;
};

export default DeductibleSummary;
